// //constants
// const FETCH_ALL_OPEN_FRESHDESK_TICKETS = LMS_SERVICE_API_PREFIX + "/supportTicket/ticketsForUserByStatus";
//
// //functions for URL composition
// const fetchTicketDetailsByTicketIdUrl = (ticketId: string) => LMS_SERVICE_API_PREFIX + `/supportTicket/fetch/${ticketId}`;
// const fetchTicketConversationByTicketIdUrl = ({ ticketId, page, limit }: IFetchTicketConversationByTicketIdParams) =>
// 	LMS_SERVICE_API_PREFIX + `/supportTicket/conversations/${ticketId}?limit=${limit}&page=${page}`;

import { ILmsService } from "./ILmsService"
import {
	IFetchAllFreshDeskTicketsParams,
	IFetchAllFreshDeskTicketsResponse,
	IFetchTicketConversationByTicketIdParams,
	IFetchTicketConversationByTicketIdResponse,
	IFetchTicketDetailsByTicketIdResponse,
} from "./LmsServiceModels"
import ApiUtils from "../ApiUtils"

const LmsUrls = {
	fetchOpenFreshdeskTicket: "/supportTicket/ticketsForUserByStatus",
	fetchTicketDetailsByTicketId: (ticketId: string) => `/supportTicket/fetch/${ticketId}`,
	fetchTicketConversationByTicketIdUrl: ({ ticketId, page, limit }: IFetchTicketConversationByTicketIdParams) => `/supportTicket/conversations/${ticketId}?limit=${limit}&page=${page}`,
}
export default class LmsServiceApis implements ILmsService {
	getServiceUrl = (url: string) => "/lms" + url
	fetchAllOpenFreshDeskTickets = (params: IFetchAllFreshDeskTicketsParams): Promise<IFetchAllFreshDeskTicketsResponse[]> => {
		return ApiUtils.post(this.getServiceUrl(LmsUrls.fetchOpenFreshdeskTicket), params)
	}
	fetchTicketDetailsByTicketId = (ticketId: string): Promise<IFetchTicketDetailsByTicketIdResponse> => {
		const url = this.getServiceUrl(LmsUrls.fetchTicketDetailsByTicketId(ticketId))
		return ApiUtils.get(url)
	}
	fetchTicketConversationByTicketId = (params: IFetchTicketConversationByTicketIdParams): Promise<IFetchTicketConversationByTicketIdResponse> => {
		const url = this.getServiceUrl(LmsUrls.fetchTicketConversationByTicketIdUrl(params))
		return ApiUtils.get(url)
	}
}
